import { kea } from 'kea'
import PropTypes from "prop-types";
import {get, forEach} from "lodash";
import {call, put, select} from "redux-saga/effects";
import { Contacts, Carts } from '@gratify-eu/entities'

import {
  NAME_LAST_NAME,
  NAME_FULL_NAME,
  ADDRESS_FOR_COMPANY_ONLY,
  ADDRESS_ENABLED,
  ADDRESS_LINE_2_HIDDEN,
  PHONE_NUMBER_OPTIONAL,
  PHONE_NUMBER_REQUIRED
} from '~/constants/checkout-settings'

import { selector as configSelector } from '~/config'

import entities from '~/entities'
import createForm from '~/utils/create-form'
import rootLogic from '~/scenes/logic'


import { contact, defaults, fillWithDefaults, propTypes } from '~/components/contacts'
export const form = createForm({propTypes, defaults});


export default kea({
  path: () => ['scenes', 'contact', 'form'],
  connect: {
    actions: [
      form, [
        'setValue',
        'setValues',
        'submit',
        'submitSuccess',
        'submitFailure'
      ]
    ],
    values: [
      form, [
        'values',
        'isSubmitting',
        'errors',
        'submitErrors'
      ],
      rootLogic, [
        'userInfo'
      ]
    ]
  },
  actions: () => ({
    setFormLoading: true,
    formLoaded: true,
  }),

  reducers: ({ actions, constants }) => ({
    formLoading: [false, PropTypes.bool, {
      [actions.setFormLoading]: () => (true),
      [actions.formLoaded]: () => (false),
    }],
  }),

  selectors : ({ constants, selectors }) => ({
    contactFields: [
      () => [
        entities.selectors.activeShop,
        selectors.values
      ], (activeShop, formValues) => {

        const fields = contact;

        if(activeShop && activeShop.checkout_settings) {
          const {
            name,
            address,
            address_line_2,
            phone_number,
            enable_company_billing,
            subscribe_to_newsletter_check
          } = activeShop.checkout_settings

          let chosenFields = {
            email: fields.email
          };

          switch (name) {
            case NAME_LAST_NAME:
              chosenFields.last_name = fields.last_name;
              break;
            case NAME_FULL_NAME:
              chosenFields.first_name = fields.first_name;
              chosenFields.last_name = fields.last_name;
              break;
          }

          switch (phone_number) {
            case PHONE_NUMBER_OPTIONAL:
            case PHONE_NUMBER_REQUIRED:
              chosenFields.phone = fields.phone;
          }

          if(enable_company_billing) {
            chosenFields.company_billing = fields.company_billing;
            if(formValues.company_billing) {
              chosenFields.company = fields.company;
            }
          }

          if(subscribe_to_newsletter_check) {
            chosenFields.subscribe_to_newsletter = fields.subscribe_to_newsletter;
          }

          if((address === ADDRESS_FOR_COMPANY_ONLY && formValues.company_billing) || address === ADDRESS_ENABLED) {
            chosenFields.address = Object.assign({}, fields.address);

            if(address_line_2 === ADDRESS_LINE_2_HIDDEN) {
              delete chosenFields.address.address_line_2;
            }
          }

          return chosenFields;
        }
        return fields;
      },
      PropTypes.object
    ],
    activeContact: [
      () => [
        entities.selectors.activeCart,
        entities.selectors.contacts,
      ], (activeCart, contacts) => {
        if(activeCart && contacts) {
          if(activeCart.contact) {
            return get(contacts, activeCart.contact, null);
          }
        }

        return null;
      },
      PropTypes.object
    ]
  }),
  start: function* () {
    const { setFormLoading, formLoaded, setValues } = this.actionCreators;
    const activeCart = yield entities.get('activeCart');
    const activeContact = yield this.get('activeContact');
    const userInfo = yield this.get('userInfo');
    const config  = yield select(configSelector);
    let userInfoDefaults = {};
    if(userInfo && userInfo.email) {
      userInfoDefaults.email = userInfo.email;
    }

    if(config && config.cartDefaults && config.cartDefaults.contact) {
      userInfoDefaults = {
        ...userInfoDefaults,
        ...(config.cartDefaults.contact || {})
      }
    }
    // Attempt to load the active contact if it is not loaded yet
    if(activeCart.contact && activeContact) {
      yield put(setValues(fillWithDefaults(activeContact, userInfoDefaults)));
    } else if(activeCart.contact && !activeContact) {
      yield put(setFormLoading());

      try {
        const contact = yield call(Contacts.workers.fetch, {payload: {url: activeCart.contact}}, true);
        yield put(setValues(fillWithDefaults(contact, userInfoDefaults)));
        yield put(formLoaded());
      } catch(e) {
        yield put(formLoaded());
      }
    }else {
      yield put(setValues(fillWithDefaults(userInfoDefaults)));
    }

  },
  takeLatest: ({ actions, workers }) => ({
    [actions.submit]: function * () {
      const { submitSuccess, submitFailure } = this.actionCreators

      console.log('submit');
      try {
        const values = yield this.get('values');
        const activeShop = yield entities.get('activeShop');
        const contactFields = yield this.get('contactFields');
        const activeContact = yield this.get('activeContact');

        let contactData = {...(activeContact && activeContact.id ? {} : defaults), shop: activeShop.url};

        forEach(contactFields, (field, key) => {
          contactData[key] = values[key];
        });

        if(!contactFields.address) {
          contactData.address = null;
        }

        let contact;
        if(activeContact && activeContact.id) {
          contact = yield call(Contacts.workers.update, Contacts.actions.update.request(activeContact.id, contactData), true);
        }else {
          contact = yield call(Contacts.workers.create, Contacts.actions.create.request(contactData), true);
        }


        const activeCart = yield entities.get('activeCart');

        try {

          yield call(Carts.workers.update, Carts.actions.update.request(activeCart.id, {contact: contact.url}), true);

          yield put(submitSuccess(contact))

        } catch(error) {
          const errors = get(error, 'response.data.contact');
          if(errors) {
            yield put(submitFailure(errors))
          }
        }

      } catch (error) {
        const errors = get(error, 'response.data');
        if(errors) {
          yield put(submitFailure(errors))
        }
        console.log('error', error);
      }
    }
  })
})
